export default {
  section: 'Salida de inventario',
  create: 'Capturar mermas',
  loading: 'Cargando productos...',
  headers: {
    name: 'Producto',
    quantity: 'Cantidad',
    actions: 'Acciones',
    description: 'Descripción',
    unit: 'Unidad de medida'
  }
}
